import { render } from "./FirstStepsExplanation.vue?vue&type=template&id=0068973b"
import script from "./FirstStepsExplanation.vue?vue&type=script&lang=js"
export * from "./FirstStepsExplanation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__